export const GET_ALL_TRANSLATION_LANGUAGES = 'GET_ALL_TRANSLATION_LANGUAGES';
export const GET_ALL_TRANSLATION_LANGUAGES_SUCCESS =
  'GET_ALL_TRANSLATION_LANGUAGES_SUCCESS';
export const GET_ALL_TRANSLATION_LANGUAGES_ERROR =
  'GET_ALL_TRANSLATION_LANGUAGE_ERROR';
export const CREATE_TRANSLATION_LANGUAGE = 'CREATE_TRANSLATION_LANGUAGE';
export const CREATE_TRANSLATION_LANGUAGE_SUCCESS =
  'CREATE_TRANSLATION_LANGUAGE_SUCCESS';
export const CREATE_TRANSLATION_LANGUAGE_ERROR =
  'CREATE_TRANSLATION_LANGUAGE_ERROR';
export const UPDATE_TRANSLATION_LANGUAGE = 'UPDATE_TRANSLATION_LANGUAGE';
export const UPDATE_TRANSLATION_LANGUAGE_SUCCESS =
  'UPDATE_TRANSLATION_LANGUAGE_SUCCESS';
export const UPDATE_TRANSLATION_LANGUAGE_ERROR =
  'UPDATE_TRANSLATION_LANGUAGE_ERROR';
export const DELETE_TRANSLATION_LANGUAGE = 'DELETE_TRANSLATION_LANGUAGE';
export const DELETE_TRANSLATION_LANGUAGE_SUCCESS =
  'DELETE_TRANSLATION_LANGUAGE_SUCCESS';
export const DELETE_TRANSLATION_LANGUAGE_ERROR =
  'DELETE_TRANSLATION_LANGUAGE_ERROR';
